import React, { useState } from "react"
import * as footerStyles from "./Footer.module.scss"
import Section from "../main/section/Section"
import Button from "../../../lib/common/blocks/button/Button"
import Icon from "../../../lib/common/blocks/icon/Icon"
import Image from "../../../lib/common/blocks/image/Image"

const Footer = ({ siteData, setForceCookiesSettings, forceCookiesSettings }) => {
  const currentYear = new Date().getFullYear()
  const footerLogoData = siteData?.attributes?.footerLogo
  const [activeLists, setActiveLists] = useState([])

  const toggleLinksList = (index) => {
    setActiveLists((prevState) => {
      const newState = [...prevState]
      newState[index] = !newState[index]
      return newState
    })
  }
  const renderFooterLinks = () => {
    return siteData?.attributes.footerColumns.map((item, index) => {
      let collection = item.selPages.map((sp) => {
        return {
          label: sp.label,
          ctaLink: sp.linkCtaLink,
        }
      })
      return (
        <div key={index}>
          <Button
            aspect="unstyled"
            onClick={() => toggleLinksList(index)}
            className={footerStyles.nav__title}
          >
            {item.label}
            <Icon
              icon={activeLists[index] ? "arrowUpBleu" : "arrowDownBleu"}
              className="xs-block lg-none"
            />
          </Button>
          <ul
            className={`${footerStyles.linksList} ${
              activeLists[index] ? footerStyles.active : ""
            }`}
          >
            {collection.map((subItem, subIndex) => (
              <li key={subIndex}>
                <Button
                  aspect="unstyled"
                  color="unstyled"
                  ctalink={subItem.ctaLink}
                >
                  {subItem.label}
                </Button>
              </li>
            ))}
          </ul>
        </div>
      )
    })
  }

  const renderSocialIcons = () => {
    return (
      <ul>
        {siteData?.attributes.footerReseauSociaux.map((item, index) => (
          <li key={index}>
            <a
              href={item.lien}
              target="_blank"
              rel="noreferrer"
            >
              <Image
                imgSrc={item.icone.data?.attributes.url}
                imgAlt={item.icone.data?.attributes.alternativeText}
                imgWidth={item.icone.data?.attributes.width}
                imgHeight={item.icone.data?.attributes.height}
                formats={item.icone.data?.attributes?.formats}
              />
            </a>
          </li>
        ))}
      </ul>
    )
  }

  const renderColophonLinks = () => {
    return siteData?.attributes.selPagesColophon.map((item, index) => (
      <li key={index}>
        <Button
          aspect="unstyled"
          color="unstyled"
          ctalink={item.linkCtaLink}
        >
          {item.label}
        </Button>
      </li>
    ))
  }

  return (
    <footer className={footerStyles.footer}>
      <Section
        className="p-0"
        container="xlarge"
      >   
        <div className={footerStyles.wrapper}>
          <div className={footerStyles.brand}>
            <Button
              aspect="unstyled"
              color="unstyled"
              to="/"
            >
              <Image
                imgSrc={footerLogoData?.data?.attributes?.url}
                imgAlt={footerLogoData?.data?.attributes?.alternativeText}
                imgWidth={footerLogoData?.data?.attributes?.width}
                imgHeight={footerLogoData?.data?.attributes?.height}
                formats={footerLogoData?.data?.attributes?.formats}
              />
            </Button>
            <div className={footerStyles.infos}>
              {siteData?.attributes.footerBaseline}
            </div>
            <div className={`${footerStyles.social} xs-none lg-block`}>
              {renderSocialIcons()}
            </div>
          </div>
          <nav>{renderFooterLinks()}</nav>
        </div>
      </Section>
      <hr />
      <Section
        className="p-0"
        container="xlarge"
      >
        <div className={footerStyles.colophon}>
          <nav>
            <ul>
              <li className={footerStyles.copyright}>
                ©&nbsp;{currentYear}&nbsp;
                {siteData?.attributes.copyright}
              </li>
              <li>
                <Button
                      aspect="unstyled"
                      size="xsmall"
                      style={{ color: "var(--gris)" }}
                      onClick={() => {
                        setForceCookiesSettings(true)
                      }}
                    >
                      Cookies
                </Button>
              </li>
              {renderColophonLinks()}
            </ul>
          </nav>
          <div className={`${footerStyles.social} xs-block lg-none`}>
            {renderSocialIcons()}
          </div>
        </div>
      </Section>
    </footer>
  )
}

export default Footer
